import { getTranslator } from "../i18n";

function isValidDeliveryPath(path) {
    if (!path || path.startsWith("thumb-")) {
        return false;
    }

    if (path.includes("..")) {
        return false;
    }

    if (/[\0\r\n\\]/.test(path)) {
        return false;
    }

    const segments = path.split("/");
    if (segments.some((segment) => segment === "" || segment === ".")) {
        return false;
    }

    return true;
}

export function normalizeAlbumPath(input) {
    return String(input || "")
        .trim()
        .replace(/^\/+/, "")
        .replace(/\/+$/, "");
}

export function parseDeliveryPath(input) {
    const t = getTranslator();
    const path = normalizeAlbumPath(input);
    if (!path) {
        throw new Error(t("delivery.admin.pathRequired"));
    }

    if (!isValidDeliveryPath(path)) {
        throw new Error(t("delivery.admin.pathInvalid"));
    }

    return { t: "d", i: path };
}

export function toFolderPrefix(albumPath) {
    const normalized = normalizeAlbumPath(albumPath);
    return normalized ? `${normalized}/` : "";
}

export function toThumbKey(originalKey) {
    const key = normalizeAlbumPath(originalKey);
    if (!key) {
        return "";
    }
    const slashIndex = key.indexOf("/");
    if (slashIndex === -1) {
        return `thumb-${key}`;
    }
    const root = key.slice(0, slashIndex);
    const rest = key.slice(slashIndex);
    return `thumb-${root}${rest}`;
}

export function getFolderDisplayName(prefix) {
    const t = getTranslator();
    const normalized = normalizeAlbumPath(prefix);
    if (!normalized) {
        return t("delivery.actions.defaultAlbumName");
    }
    const parts = normalized.split("/");
    return parts[parts.length - 1] || t("delivery.actions.defaultAlbumName");
}

export function getDeliveryPublicBase() {
    return (process.env.REACT_APP_DELIVERY_PUBLIC_BASE || "").replace(/\/+$/, "");
}

export function toDeliveryPublicUrl(key) {
    const base = getDeliveryPublicBase();
    if (!base || !key) {
        return null;
    }
    const encodedPath = key
        .split("/")
        .map((segment) => encodeURIComponent(segment))
        .join("/");
    return `${base}/${encodedPath}`;
}
